const StarIcon = (props) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
    d="M8 4L9.27279 8.72721L14 10L9.27279 11.2728L8 16L6.72721 11.2728L2 10L6.72721 8.72721L8 4Z"
    fill="currentColor"
  />
  <path
    d="M14.5 2L15.0303 3.96967L17 4.5L15.0303 5.03033L14.5 7L13.9697 5.03033L12 4.5L13.9697 3.96967L14.5 2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default StarIcon;
